import { type Writable, writable } from 'svelte/store';

import { linkInitValue } from '../constants';
import { type ILink } from '../models';

export const link: Writable<ILink> = writable({ ...linkInitValue });
